import * as moment from 'moment';
import { Component } from '@angular/core';
import { ModalController } from 'ionic-angular';

import { DayEntryModel, UserModel } from '../../../models/models';
import { ConfigurationProvider, DayEntryProvider, UserProvider } from '../../../providers/providers';
import { DashboardLogFoodPage } from './dashboard-log-food';
import { DashboardLogSupplementPage } from './dashboard-log-supplement';
import { DashboardNotesPage } from '../dashboard-notes';

@Component({
  selector: 'page-dashboard-nutrition',
  templateUrl: 'dashboard-nutrition.html'
})
export class DashboardNutritionPage {
  dayEntry: any = null;
  dayEntryTargets: any = null;
  dayEntryList: any = [];
  isLoaded: boolean = false;
  isToday: boolean = true;
  isWeightLoss: boolean = false;
  calDate: string;
  startDate: moment.Moment;
  todayDate: string;
  user: UserModel;

  constructor(
    private config: ConfigurationProvider,
    private dayEntryProvider: DayEntryProvider,
    private modalCtrl: ModalController,
    private userProvider: UserProvider) {
  }

  doAddFood(dayEntry: DayEntryModel) {
    let passEntry = Object.assign({}, dayEntry);
    passEntry.FoodItems = [];
    let modal = this.modalCtrl.create(DashboardLogFoodPage, { 
      dayEntry: passEntry,
      user: this.user
    });
    modal.present();

    modal.onDidDismiss(data => {
      if (data && data.saved && data.date) {
        this.dayEntry = passEntry;
        this.config.showToast(`Food saved for ${data.date}`);
        this.loadDayEntries(moment(dayEntry.Date), true);
      }
    });
  }

  doChangeDate(data) {
    this.doChangeDay(0, moment(`${data.month} ${data.day} ${data.year}`));
  }

  doChangeDay(direction: number, newDate: moment.Moment = null) {
    if (!newDate) {
      newDate = direction === 0 ? moment() : moment(this.startDate).add(direction, 'day');
    }
    if (newDate <= moment()) {
      const hasDate = this.dayEntryList.find(x => moment(x.Date).format('YYYY-MM-DD') === newDate.format('YYYY-MM-DD'));
      if (hasDate === undefined) {
        this.loadDayEntries(newDate);
      }
      this.dayEntryProvider.SetDate(newDate);
      this.dayEntry = this.dayEntryProvider.Get(newDate);
      this.isToday = moment(newDate).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD');
      this.calDate = newDate.format('YYYY-MM-DD');
      this.startDate = newDate;
    }
  }

  doEditNotes(dayEntry: DayEntryModel) {
    let modal = this.modalCtrl.create(DashboardNotesPage, { 
      dayEntry: dayEntry,
      user: this.user
    });
    modal.present();

    modal.onDidDismiss(data => {
      if (data && data.saved && data.date) {
        this.config.showToast(`Notes saved for ${data.date}`);
        this.dayEntry.Notes = data.notes;
        this.loadDayEntries(moment(dayEntry.Date), true);
      }
    });
  }

  doEditSupplements(dayEntry: DayEntryModel) {
    let passEntry = Object.assign({}, dayEntry);
    passEntry.Supplements = [];
    let modal = this.modalCtrl.create(DashboardLogSupplementPage, { 
      dayEntry: dayEntry,
      user: this.user
    });
    modal.present();

    modal.onDidDismiss(data => {
      if (data && data.saved && data.date) {
        this.dayEntry = passEntry;
        this.config.showToast(`Supplements saved for ${data.date}`);
        this.loadDayEntries(moment(dayEntry.Date), true);
      }
    });
  }

  doChangeWeightMode() {
    this.dayEntry.NutritionTarget.Calories = this.config.fixDecimals(this.dayEntryTargets.Calories * (this.isWeightLoss ? 0.8 : 1));
    this.dayEntry.NutritionTarget.Fat = this.config.fixDecimals(this.dayEntryTargets.Fat * (this.isWeightLoss ? 0.8 : 1));
    this.dayEntry.NutritionTarget.Carbohydrates = this.config.fixDecimals(this.dayEntryTargets.Carbohydrates * (this.isWeightLoss ? 0.8 : 1));
    this.dayEntry.NutritionTarget.Protein = this.config.fixDecimals(this.dayEntryTargets.Protein * (this.isWeightLoss ? 0.8 : 1));
    // percents
    this.dayEntry.TargetPercentage = this.config.getNutritionTargetPercent(this.dayEntry.Nutrition, this.dayEntry.NutritionTarget);
  }

  doSwipe(e) {
    this.doChangeDay(e.direction === 4 ? -1 : 1);
  }

  ionViewDidLoad() {
    this.startDate = moment();
    this.calDate = this.startDate.format('YYYY-MM-DD');
    this.todayDate = this.startDate.format('YYYY-MM-DD');
    this.user = this.userProvider.Get();
    this.loadView();
  }

  loadDayEntries(startDate: moment.Moment, merge: boolean = false) {
    this.config.showLoading();
    this.isLoaded = false;
    this.dayEntryProvider.Load(this.user._id, startDate, true, merge).then((items: DayEntryModel[]) => {
      this.loadItems(items, startDate);
      this.config.dismissLoading();
    });
  }

  loadItems(items, startDate) {
    for (let item of items as any[]) {
      item.icon = 'arrow-dropleft';
      item.showDetails = false;
    }
    this.dayEntryList = items;
    this.dayEntry = this.dayEntryProvider.Get(startDate);
    this.dayEntryTargets = Object.assign({}, this.dayEntry.NutritionTarget);
    this.isToday = moment(startDate).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD');
    this.calDate = startDate.format('YYYY-MM-DD');
    this.startDate = startDate;
    this.isLoaded = true;
  }

  loadView() {
    if (this.user == null) {
      this.config.showLoading();
      this.userProvider.Load(1).then((x: UserModel) => {
        this.user = x;
        this.config.dismissLoading();
        this.loadDayEntries(this.startDate);
      });
    }
    else {
      this.loadItems(this.dayEntryProvider.List(), this.dayEntryProvider.GetDate());
    }
  }

  toggleDetails(item) {
    if (item.Nutrition.Calories > 0) {
      const showDetails = (item) => {

        let time = '';
        let meal_id = 0;
        item.FoodItems.map(x => {
          if (time !== x['TimeDisplay']) {
            time = x['TimeDisplay'];
            x['new_time'] = true;
          }
          if (meal_id !== x['MealId']) {
            meal_id = x['MealId'];
            x['new_meal'] = true;
            var foods = item.FoodItems.filter(y => y.MealId === x.MealId);
            x['meal_cals'] = foods.reduce((sum, cur) => sum + cur.Nutrition.Calories, 0);
            x['meal_fats'] = foods.reduce((sum, cur) => sum + cur.Nutrition.Fat, 0);
            x['meal_carb'] = foods.reduce((sum, cur) => sum + cur.Nutrition.Carbohydrates, 0);
            x['meal_prot'] = foods.reduce((sum, cur) => sum + cur.Nutrition.Protein, 0);
          }
        });

        if (item.showDetails) {
          item.showDetails = false;
          item.icon = 'arrow-dropleft';
        }
        else {
          item.showDetails = true;
          item.icon = 'arrow-dropdown';
        }
      };

      if (item.FoodItems) {
        showDetails(item);
      }
      else {
        this.config.showLoading();
        this.dayEntryProvider.LoadFoodItems(this.user._id, item).then((dayEntry: DayEntryModel) => {
          item = dayEntry;
          showDetails(item);
          this.config.dismissLoading();
        });
      }
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/dashboard/nutrition/dashboard-nutrition.ts